import { useEffect } from 'react'
import { useCurrencyStore } from '../stores/useCurrencyStore'

const NigeriaFlag = () => (
  <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2507_500)">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0.848145H18V14.3481H0V0.848145Z" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.9981 0.848145H18V14.3481H11.9981V0.848145ZM0 0.848145H5.99906V14.3481H0V0.848145Z" fill="#008753"/>
    </g>
    <defs>
      <clipPath id="clip0_2507_500">
        <rect width="18" height="13.5" fill="white" transform="translate(0 0.848145)"/>
      </clipPath>
    </defs>
  </svg>
)

const USAFlag = () => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.987865 0.541992H17.0056C17.5501 0.541992 17.9935 0.98539 17.9935 1.52986V12.0703C17.9935 12.6148 17.5501 13.0582 17.0056 13.0582H0.987865C0.443398 13.0615 0 12.6181 0 12.0736V1.52986C0 0.98539 0.443398 0.541992 0.987865 0.541992Z" fill="#B22234"/>
    <path d="M0.00652056 1.43262H17.9935C17.9967 1.46522 18 1.49782 18 1.53369V2.49221H0V1.53043C0 1.49782 0.00326028 1.46522 0.00652056 1.43262ZM17.9967 3.36922V4.42555H0V3.36922H17.9967ZM17.9967 5.30583V6.36216H0V5.30583H17.9967ZM17.9967 7.24243V8.29877H0V7.24243H17.9967ZM17.9967 9.17904V10.2354H0V9.17904H17.9967ZM17.9967 11.1156V12.0709C17.9967 12.1035 17.9935 12.1394 17.9902 12.172H0.00652056C0.00326028 12.1426 0 12.1068 0 12.0742V11.1189H17.9967V11.1156Z" fill="white"/>
    <path d="M6.78138 0.541992V7.28425H0V1.52986C0 0.98539 0.443398 0.541992 0.987865 0.541992H6.78138Z" fill="#3C3B6E"/>
    <path d="M0.401615 1.4751L0.626574 2.17606L0.0332031 1.74244H0.770026L0.173395 2.17606L0.401615 1.4751Z" fill="white"/>
    <path d="M0.401615 2.83105L0.626574 3.53201L0.0332031 3.0984H0.770026L0.173395 3.53201L0.401615 2.83105Z" fill="white"/>
    <path d="M0.401615 4.1875L0.626574 4.88846L0.0332031 4.45484H0.770026L0.173395 4.88846L0.401615 4.1875Z" fill="white"/>
    <path d="M0.401615 5.54346L0.626574 6.24442L0.0332031 5.8108H0.770026L0.173395 6.24442L0.401615 5.54346Z" fill="white"/>
    <path d="M1.19654 0.796387L1.42476 1.49735L0.828125 1.06373H1.56821L0.968317 1.49735L1.19654 0.796387Z" fill="white"/>
    <path d="M1.19654 2.15283L1.42476 2.85379L0.828125 2.42017H1.56821L0.968317 2.85379L1.19654 2.15283Z" fill="white"/>
    <path d="M1.19654 3.50928L1.42476 4.21024L0.828125 3.77662H1.56821L0.968317 4.21024L1.19654 3.50928Z" fill="white"/>
    <path d="M1.19654 4.86523L1.42476 5.56619L0.828125 5.13258H1.56821L0.968317 5.56619L1.19654 4.86523Z" fill="white"/>
    <path d="M1.19654 6.22168L1.42476 6.92264L0.828125 6.48902H1.56821L0.968317 6.92264L1.19654 6.22168Z" fill="white"/>
    <path d="M1.99536 1.4751L2.22358 2.17606L1.62695 1.74244H2.36378L1.76715 2.17606L1.99536 1.4751Z" fill="white"/>
    <path d="M1.99536 2.83105L2.22358 3.53201L1.62695 3.0984H2.36378L1.76715 3.53201L1.99536 2.83105Z" fill="white"/>
    <path d="M1.99536 4.1875L2.22358 4.88846L1.62695 4.45484H2.36378L1.76715 4.88846L1.99536 4.1875Z" fill="white"/>
    <path d="M1.99536 5.54346L2.22358 6.24442L1.62695 5.8108H2.36378L1.76715 6.24442L1.99536 5.54346Z" fill="white"/>
    <path d="M2.79419 0.796387L3.01915 1.49735L2.42578 1.06373H3.1626L2.56597 1.49735L2.79419 0.796387Z" fill="white"/>
    <path d="M2.79419 2.15283L3.01915 2.85379L2.42578 2.42017H3.1626L2.56597 2.85379L2.79419 2.15283Z" fill="white"/>
    <path d="M2.79419 3.50928L3.01915 4.21024L2.42578 3.77662H3.1626L2.56597 4.21024L2.79419 3.50928Z" fill="white"/>
    <path d="M2.79419 4.86523L3.01915 5.56619L2.42578 5.13258H3.1626L2.56597 5.56619L2.79419 4.86523Z" fill="white"/>
    <path d="M2.79419 6.22168L3.01915 6.92264L2.42578 6.48902H3.1626L2.56597 6.92264L2.79419 6.22168Z" fill="white"/>
    <path d="M3.58911 1.4751L3.81733 2.17606L3.2207 1.74244H3.95753L3.3609 2.17606L3.58911 1.4751Z" fill="white"/>
    <path d="M3.58911 2.83105L3.81733 3.53201L3.2207 3.0984H3.95753L3.3609 3.53201L3.58911 2.83105Z" fill="white"/>
    <path d="M3.58911 4.1875L3.81733 4.88846L3.2207 4.45484H3.95753L3.3609 4.88846L3.58911 4.1875Z" fill="white"/>
    <path d="M3.58911 5.54346L3.81733 6.24442L3.2207 5.8108H3.95753L3.3609 6.24442L3.58911 5.54346Z" fill="white"/>
    <path d="M4.38794 0.796387L4.61616 1.49735L4.01953 1.06373H4.75635L4.15972 1.49735L4.38794 0.796387Z" fill="white"/>
    <path d="M4.38794 2.15283L4.61616 2.85379L4.01953 2.42017H4.75635L4.15972 2.85379L4.38794 2.15283Z" fill="white"/>
    <path d="M4.38794 3.50928L4.61616 4.21024L4.01953 3.77662H4.75635L4.15972 4.21024L4.38794 3.50928Z" fill="white"/>
    <path d="M4.38794 4.86523L4.61616 5.56619L4.01953 5.13258H4.75635L4.15972 5.56619L4.38794 4.86523Z" fill="white"/>
    <path d="M4.38794 6.22168L4.61616 6.92264L4.01953 6.48902H4.75635L4.15972 6.92264L4.38794 6.22168Z" fill="white"/>
    <path d="M5.18482 1.4751L5.41304 2.17606L4.81641 1.74244H5.55323L4.95986 2.17606L5.18482 1.4751Z" fill="white"/>
    <path d="M5.18482 2.83105L5.41304 3.53201L4.81641 3.0984H5.55323L4.95986 3.53201L5.18482 2.83105Z" fill="white"/>
    <path d="M5.18482 4.1875L5.41304 4.88846L4.81641 4.45484H5.55323L4.95986 4.88846L5.18482 4.1875Z" fill="white"/>
    <path d="M5.18482 5.54346L5.41304 6.24442L4.81641 5.8108H5.55323L4.95986 6.24442L5.18482 5.54346Z" fill="white"/>
    <path d="M5.98169 0.796387L6.20991 1.49735L5.61328 1.06373H6.3501L5.75347 1.49735L5.98169 0.796387Z" fill="white"/>
    <path d="M5.98169 2.15283L6.20991 2.85379L5.61328 2.42017H6.3501L5.75347 2.85379L5.98169 2.15283Z" fill="white"/>
    <path d="M5.98169 3.50928L6.20991 4.21024L5.61328 3.77662H6.3501L5.75347 4.21024L5.98169 3.50928Z" fill="white"/>
    <path d="M5.98169 4.86523L6.20991 5.56619L5.61328 5.13258H6.3501L5.75347 5.56619L5.98169 4.86523Z" fill="white"/>
    <path d="M5.98169 6.22168L6.20991 6.92264L5.61328 6.48902H6.3501L5.75347 6.92264L5.98169 6.22168Z" fill="white"/>
  </svg>
)

export function CurrencyToggle() {
  const { currency, setCurrency, fetchRates, rates } = useCurrencyStore()

  useEffect(() => {
    
    if (!rates || useCurrencyStore.getState().shouldFetchRates()) {
      fetchRates()
    }
  }, [rates, fetchRates])

  const currencies = [
    {
      currency: 'NGN' as const,
      flag: <NigeriaFlag />
    },
    {
      currency: 'USD' as const,
      flag: <USAFlag />
    }
  ]

  const styles = {
    active: 'text-[#FBFBFE] bg-[#28282A] w-full h-full',
    inactive: 'text-foreground bg-muted w-full h-full'
  }

  return (
    <div className="w-[110px] lg:w-[135px] h-[40px] flex items-center border-[1px] border-[#D9D9D9] rounded-md">
      {currencies.map((country, idx) => (
        <div
          key={idx}
          onClick={() => setCurrency(country.currency)}
          className={`flex items-center cursor-pointer w-1/2 h-full rounded-md justify-center text-[14px] font-[700] ${
            currency === country.currency ? styles.active : styles.inactive
          }`}
        >
          {country.flag}
          <span className="ml-1">{country.currency}</span>
        </div>
      ))}
    </div>
  )
}